import { lazy, Suspense } from "react";

import Loading from "./../components/feedback/Loading";
import { Route, Routes } from "react-router-dom";

const Root_Layout = lazy(() => import("../components/layout/Root_Layout"));
const Home = lazy(() => import("../pages/home/Home"));

// Policies
const Policies = lazy(() => import("../pages/policies/Policies"));

const Developer = lazy(() => import("../pages/developer/Developer"));

// investment-calculator
const InvestmentCalculator = lazy(
  () => import("../pages/investment_calculator/Investment_Calculator"),
);

// not found
const Not_Found = lazy(() => import("../pages/404/Not_Found"));

const App_Routes = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/" element={<Root_Layout />}>
          <Route index element={<Home />} />
          <Route path="developer" element={<Developer />} />
          <Route
            path="privacy-policy"
            element={<Policies type="privacy_policy" />}
          />
          <Route
            path="terms-and-conditions"
            element={<Policies type="terms" />}
          />
          <Route
            path="conflict-of-interest"
            element={<Policies type="conflict_of_interest_policy" />}
          />
          <Route
            path="opening-agreement"
            element={<Policies type="account_opening_agreement" />}
          />
          <Route
            path="investment-calculator"
            element={<InvestmentCalculator />}
          />
          <Route path="*" element={<Not_Found />} />
        </Route>
      </Routes>
    </Suspense>
  );
};
export default App_Routes;
